import {faCamera, faImage} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useGlobalState} from 'hooks/useGlobalState';
import './ProfileImage.scss';
import User from 'typescript/models/User';

interface IProps {
  singleEditor: User;
  onEdit: () => void;
}

export default function ProfileImage({singleEditor, onEdit}: IProps) {
  const {previewSrc} = useGlobalState((state) => state.imageUploader);

  const imageSrc = previewSrc || singleEditor?.attributes.profile_image;

  return (
    <div className="profile-image">
      {imageSrc ? (
        <img className="profile-image__image" src={imageSrc} alt="Page editor profile" />
      ) : (
        <div className="profile-image__image-placeholder">
          <FontAwesomeIcon icon={faImage} />
        </div>
      )}
      <button onClick={onEdit} type="button" className="profile-image__upload-photo">
        <FontAwesomeIcon icon={faCamera} />
        Upload Photo
      </button>
    </div>
  );
}
